"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var contains_1 = require("./contains");
var values_1 = require("./values");
exports.default = (function (obj, value) { return contains_1.default(values_1.default(obj), value); });
//# sourceMappingURL=has-value.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/has-value.js
// module id = 1106
// module chunks = 37